/* ক্রিয়েটর-পোর্টালের সাঝা ছোট জিনিস — বড় বোতাম, ঘুরঁতে টগল, অবস্থা-ব্যাজ */
export function Toggle({ on, onChange, label, testid }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => onChange(!on)}
      className={`flex items-center gap-3 rounded-full border px-4 py-2 text-sm transition-all duration-300 ${
        on ? "border-gold bg-gold/15 text-gold" : "border-sand/25 text-sand/60"
      }`}
      aria-pressed={on}
    >
      <span className={`relative h-5 w-9 rounded-full transition-colors duration-300 ${on ? "bg-gold" : "bg-sand/25"}`}>
        <span className={`absolute top-0.5 h-4 w-4 rounded-full bg-plaster transition-all duration-300 ${on ? "left-[18px]" : "left-0.5"}`} />
      </span>
      {label}
    </button>
  );
}

export function StatusBadge({ live, testid }) {
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-[11px] ${
        live ? "border-gold/50 bg-gold/10 text-gold" : "border-sand/30 text-sand/55"
      }`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${live ? "animate-flicker bg-vermilion" : "bg-sand/40"}`} />
      {live ? "LIVE" : "DRAFT"}
    </span>
  );
}

export function Avatar({ photo, name, size = "h-16 w-16" }) {
  const initial = (name || "র").trim()[0];
  return photo ? (
    <img src={photo.startsWith("http") ? photo : `${process.env.REACT_APP_BACKEND_URL}${photo}`} alt={name} className={`${size} rounded-full border-2 border-gold/40 object-cover`} />
  ) : (
    <div className={`${size} flex items-center justify-center rounded-full border-2 border-gold/40 bg-gold/10 font-display text-2xl text-gold`}>
      {initial}
    </div>
  );
}

export function BigCard({ icon: Icon, title, sub, count, onClick, testid }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className="group flex items-center gap-4 rounded-2xl border border-gold/20 bg-plaster/80 p-5 text-left transition-all duration-300 hover:border-gold/60 hover:shadow-[0_14px_40px_rgba(0,0,0,0.35)]"
    >
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-gold/25 bg-earthen/70 text-gold">
        <Icon size={20} strokeWidth={1.6} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block font-display text-xl text-sand">{title}</span>
        {sub && <span className="mt-0.5 block truncate text-xs text-sand/55">{sub}</span>}
      </span>
      {count > 0 && (
        <span className="rounded-full bg-vermilion px-2.5 py-0.5 text-xs font-medium text-alpana" data-testid={`${testid}-count`}>
          {count}
        </span>
      )}
      <span className="text-sand/40 transition-transform duration-300 group-hover:translate-x-1">→</span>
    </button>
  );
}
